
import BasePropertyView from 'BasePropertyView.js';
import Template         from 'behaviors/properties/main/auto-summary.ejs';
import widgetUtil       from 'util/WidgetUtil.js';
import listService from 'ListService.js';
//=====================================================================
//
// An instance of this view represents an auto-summary.
//
// Casey Justus, April 14, 2016
//
//=====================================================================

class MainAutoSummaryView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]'   : 'updateCheckAttributes',
            'change textarea'               : 'updateAttributes',
            'blur textarea'                 : 'lostFocus',
            'focus textarea'                : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal, {silent:true} );
        this.model.set({'widgetText': propVal}, {silent:true}  );
        this.model.trigger('widgetTextUpdated');
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        this.model.set( propName, propVal, {silent:true} );
        if (!propVal) {
           this.model.set({'widgetText': this.model.get('summary')}, {silent:true});
        } else  {
            this.model.set({ 'widgetText': widgetUtil.getWidgetText(this.model) }, {silent:true});
        }
        this.model.trigger('widgetTextUpdated');
        this.render();
    }


    render() {
        this.model.set({'autoSummaryAreaState': '', 'autosummaryChecked': ''}, {silent: true});

        let bAutoSummary = false;
        if (this.model.get('autosummary').toString() === 'true') {
            bAutoSummary = true;
        }

        if (bAutoSummary) {
            this.model.set({'autoSummaryAreaState': 'disabled', 'autosummaryChecked': 'checked'}, {silent: true});
        }
        
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }       
        
        this.delegateEvents();
        return this;
    }

}

export default MainAutoSummaryView;
